export const fontFamily = {
  fontFamily: {
    fontPrimary: 'Roboto',
    fontSecondary: 'Nunito',
  },
};
